import * as api from '../api';
import axios from 'axios';
import Vue from 'vue';
let base =api.BaseApiUrl;

//获取考核档案历史列表
export const getAssessmentFile = params => {
    return axios.get(`${base}/api/FileManagerment/GetAssessmentFile`, { params: params }).then(res => res.data);
};